import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getReportsQualityControls(companyId, query) {
	return dataTransferWrap(
		ModulesMap.REPORTS_QUALITY_CONTROLS,dtConfig[ModulesMap.REPORTS_QUALITY_CONTROLS].getReportsQualityControls,
		{
			urlParams: {
				companyId: companyId,
			},
			params: query,
		}
	)
}
function getReportsQualityControl(companyId, qualityControlId, data) {
	return dataTransferWrap(
		ModulesMap.REPORTS_QUALITY_CONTROLS,dtConfig[ModulesMap.REPORTS_QUALITY_CONTROLS].getReportsQualityControl,
		{
			urlParams: {
				companyId: companyId,

				qualityControlId,
			},
      ...data,
		}
	)
}
function getReportsQualityControlPreview(companyId, qualityControlId, data) {
	return dataTransferWrap(
		ModulesMap.REPORTS_QUALITY_CONTROLS,dtConfig[ModulesMap.REPORTS_QUALITY_CONTROLS].getReportsQualityControlPreview,
		{
			urlParams: {
				companyId: companyId,

				qualityControlId,
			},
      ...data,
		}
	)
}

export default {
	getReportsQualityControls,
	getReportsQualityControl,
	getReportsQualityControlPreview,
}
